export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">关于我们</h2>
            <p className="mt-6 text-base text-foreground-600 leading-relaxed">
              90影院创立于2019年，是一家专注于为8090后影视爱好者提供高品质在线观影服务的平台。
              我们深知这一代人对影视内容的热爱与品味，从港片黄金时代的经典到好莱坞视觉大片，
              从国产口碑佳剧到热血日漫，90影院持续收录和更新海量高清、超清、4K、蓝光画质资源。
            </p>
            <p className="mt-4 text-base text-foreground-600 leading-relaxed">
              平台采用多线路智能分流技术，确保全国用户均可流畅播放不缓冲。我们坚持每日更新，
              覆盖电影、电视剧、综艺、动漫、纪录片五大核心品类，致力于成为8090后最值得信赖的免费影视大全平台。
              无论你是怀旧重温经典，还是追赶最新热门，90影院都为你准备好了专属片单。
            </p>

            <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-6">
              {[
                { value: '2019', label: '创立年份' },
                { value: '3万+', label: '影视资源' },
                { value: '98%', label: '播放成功率' },
                { value: '50万+', label: '月活用户' },
              ].map((stat) => (
                <div key={stat.label} className="text-center p-4 rounded-lg bg-background-100 border border-background-200/60">
                  <p className="font-heading text-2xl font-bold text-primary-600">{stat.value}</p>
                  <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}